import {Component} from '@angular/core'
import {BaseComponent} from '../base.component'
import {FormsModule} from '@angular/forms'
import {MatError, MatFormField, MatInput, MatLabel, MatSuffix} from '@angular/material/input'
import {MatIcon} from '@angular/material/icon'

@Component({
  selector: 'spb-taxation-tin',
  imports: [
    FormsModule,
    MatError,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatSuffix
  ],
  templateUrl: './taxation-tin.component.html',
  providers: [{provide: BaseComponent, useExisting: TaxationTinComponent}]

})
export class TaxationTinComponent extends BaseComponent {
}
